import React from 'react';
import classNames from 'classnames';

import './NormalizePumoStyles.scss';

export const NormalizePumoStyles: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => <div className={classNames('NormalizePumoStyles', className)} {...rest} />;
